<template>
    <div class>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">告警信息</span>
          <el-button type="primary" plain @click="cancel" style="float: right; padding: 3px 0">返回</el-button>
        </div>
        <div class>
          <SForm
              ref="formref"
              :fields="formfields"
              :dataForm="rowdata"
              labelWidth="150px"
              :isShowBtn="false"
          >
          </SForm>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">终端信息</span>
        </div>
        <div class>
            <SForm
                ref="editformref"
                :fields="editformfields"
                :dataForm="rowdata"
                labelWidth="150px"
                :isShowBtn="false"
            >
            </SForm>
        </div>
      </el-card>
      <el-card>
        <div slot="header" class="clearfix">
          <span style="font-weight:600;color:#000">订单信息</span>
        </div>
        <div class>
            <SForm
                ref="lastformref"
                :fields="lastformfields"
                :dataForm="rowdata"
                labelWidth="150px"
                :isShowBtn="false"
            >
            </SForm>
        </div>
      </el-card>
      <div class="btns" style="margin-top:30px; display: flex; align-items: center; justify-content:center;">
        <el-button @click="cancel">返回</el-button>
      </div>
    </div>
</template>

  <script>
  import { HOST, EV_HOST } from "@/utils/host";
  const token = window.localStorage.getItem("token");
  export default {
    name: "dianzhuanglixiangaojingxiangqing",
    components: {},
    data() {
      return {
        rowdata: {},
        formfields: [
            {
                label: "告警原因",
                type: "div",
                prop: "alarmName",
            },
            {
                label: "告警时间",
                type: "div",
                prop: "createDate",
            },
            {
                label: "告警码",
                type: "div",
                prop: "alarmCode",
            },
            {
                label: "异常值",
                type: "div",
                prop: "actualValue",
            },
            {
                label: "告警来源",
                type: "div",
                prop: "alarmSource",
            }
        ],
        formbefore: record => {
            console.log(record);
            return record;
        },
        editformfields: [
            {
                label: "终端名称",
                type: "div",
                prop: "connectorCode",
            },
            {
                label: "终端编码",
                type: "div",
                prop: "connectorName",
            },
            {
                label: "品牌型号",
                type: "div",
                prop: "equipmentModel",
            },
            {
                label: "归属电站",
                type: "div",
                prop: "stationName",
            },
            {
                label: "归属运营商",
                type: "div",
                prop: "operatorName",
            }
        ],
        editformbefore: record => {
            console.log(record);
            return record;
        },
        lastformfields: [
            {
                label: "充电单号",
                type: "div",
                prop: "startChargeSeq",
            },
            {
                label: "用户账号",
                type: "div",
                prop: "loginName",
            },
            {
                label: "实时电度",
                type: "div",
                prop: "electricDegree",
            },
            {
                label: "实时充电时长",
                type: "div",
                prop: "duration",
            }
        ],
        lastformbefore: record => {
            console.log(record);
            return record;
        },
        id: "",
      };
    },
    computed: {
      headers() {
        // console.log(token);
        return {
          token: token
        };
      },

    },
    methods: {
        cancel() {
            this.$router.go(-1);
        },

        getDataDetail() {
          let data = {
            id: this.id
          }
          this.$store.dispatch("form/handle", {
              url: "/alarm/alarmRecord/getConnectorRecord",
              data: data,
              method: "get",
              callback: resp => {
                this.rowdata = resp
            }
          });
        }
    },
    mounted() {
      this.getDataDetail()
    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {
      this.id = this.$route.query.data
    }, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
  };
  </script>

  <style lang="less" src="" scoped>
  .avatar-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  </style>



// WEBPACK FOOTER //
// src/views/alarmManagement/pileOffLineAlarmDetail.vue